
























































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

import Modal from '@/components/Modal.vue';
import { ResolvedRegistration } from '@/core/interfaces/resolvedRegistration';
import { ResolvedRegistrationCausedBy } from '@/core/enums/resolvedRegistrationCausedBy';
import { Getter } from 'vuex-class';
import { Vehicle } from '@/core/interfaces/vehicle';
import TranslatesVehiclePhase from '@/components/mixins/TranslatesVehiclePhase';
import axios from 'axios';
import TimeRegistrations from '@/components/TimeRegistrations.vue';
import RegistrationFarmAndVehicleForm from '@/components/RegistrationFarmAndVehicleForm.vue';
import { Ticket } from '@/core/interfaces/ticket';
import { Notification } from '@/core/interfaces/notification';
import { VehicleType } from '@/core/interfaces/vehicleType';

@Component({
    components: { RegistrationFarmAndVehicleForm, TimeRegistrations, Modal },
})
export default class ResolvedRegistrationModal extends Mixins(
    TranslatesVehiclePhase,
) {
    @Prop({ default: null })
    registration!: Partial<ResolvedRegistration> | null;

    @Prop({ type: Boolean })
    locked!: boolean;

    @Prop({ type: Object, default: null })
    ticket!: Ticket | null;

    @Prop({ type: Object, default: null })
    notification!: Notification | null;

    @Getter('resolvedRegistrationPossibleCausesByVehicleTypeId')
    resolvedRegistrationPossibleCausesByVehicleTypeId!: (
        vehicleTypeId: number
    ) => string[];

    @Getter('resolvedRegistrationPossibleActionsByVehicleTypeId')
    resolvedRegistrationPossibleActionsByVehicleTypeId!: (
        vehicleTypeId: number
    ) => string[];

    @Getter('vehicleById')
    vehicleById!: (id: number) => Vehicle | null;

    @Getter('vehicleTypeById')
    vehicleTypeById!: (id: number) => VehicleType | null;

    farmId: number | null = null;

    vehicleId: number | null = null;
    vehiclePhaseId: number | null = null;

    notificationId: number | null = null;
    notificationTypeId: number | null = null;

    ticketId: number | null = null;
    from: 'ticket' | 'notification' | null = null;

    causedBy: ResolvedRegistrationCausedBy | null = null;
    causes: string[] = [];
    actions: string[] = [];

    contactedFarmer = false;
    contactedFarmerPhone = false;
    contactedFarmerTicket = false;

    contactedLelyCenterTechnician = false;
    contactedLelyCenterTechnicianPhone = false;

    contactedLelyNextTechnician = false;
    contacterLelyNextTechnicianPhone = false;

    contactedDeveloper = false;
    contactedDeveloperPhone = false;
    contactedDeveloperTicket = false;
    contactedDeveloperWhatsapp = false;

    hasTimeRegistrations = false;
    showTimeRegistrationWarning = false;
    saving = false;

    mounted(): void {
        this.from = this.ticket
            ? 'ticket'
            : this.notification
                ? 'notification'
                : null;

        if (this.registration) {
            this.farmId = this.registration.farm_id || null;
            this.vehicleId = this.registration.vehicle_id || null;
            this.vehiclePhaseId = this.registration.vehicle_phase_id || null;

            this.notificationId = this.registration.notification_id || null;
            this.notificationTypeId =
                this.registration.notification_type_id || null;

            this.ticketId = this.registration.ticket_id || null;

            this.causedBy = this.registration.caused_by || null;
            this.causes = this.registration.causes || [];
            this.actions = this.registration.actions || [];

            this.contactedFarmer =
                this.registration.contacted_farmer_phone ||
                this.registration.contacted_farmer_ticket ||
                false;
            this.contactedFarmerPhone =
                this.registration.contacted_farmer_phone || false;
            this.contactedFarmerTicket =
                this.registration.contacted_farmer_ticket || false;

            this.contactedLelyCenterTechnician =
                this.registration.contacted_lely_center_technician_phone ||
                false;
            this.contactedLelyCenterTechnicianPhone =
                this.registration.contacted_lely_center_technician_phone ||
                false;

            this.contactedLelyNextTechnician =
                this.registration.contacted_lely_next_technician_phone || false;
            this.contacterLelyNextTechnicianPhone =
                this.registration.contacted_lely_next_technician_phone || false;

            this.contactedDeveloper =
                this.registration.contacted_developer_phone ||
                this.registration.contacted_developer_ticket ||
                this.registration.contacted_developer_whatsapp ||
                false;
            this.contactedDeveloperPhone =
                this.registration.contacted_developer_phone || false;
            this.contactedDeveloperTicket =
                this.registration.contacted_developer_ticket || false;
            this.contactedDeveloperWhatsapp =
                this.registration.contacted_developer_whatsapp || false;
        } else if (this.ticket) {
            this.ticketId = this.ticket.id;
            this.farmId = this.ticket.farm_id;
            this.vehicleId = this.ticket.vehicle_id;

            if (this.ticket.notification_id) {
                this.fetchNotification(this.ticket.notification_id).then(
                    (notification) => {
                        this.notificationId = notification.id;
                        this.notificationTypeId =
                            notification.notification_type_id;
                        this.vehiclePhaseId = notification.vehicle_phase_id;
                    },
                );
            }
        } else if (this.notification) {
            this.farmId = this.notification.farm_id;
            this.vehicleId = this.notification.vehicle_id;
            this.notificationId = this.notification.id;
            this.notificationTypeId = this.notification.notification_type_id;
            this.vehiclePhaseId = this.notification.vehicle_phase_id;
        }
    }

    async submit(): Promise<void> {
        if (this.locked) {
            this.$emit('close');
            return;
        }

        if (!this.hasTimeRegistrations) {
            this.showTimeRegistrationWarning = true;
            this.$nextTick(() => {
                (this.$refs.timeRegistrationWarning as HTMLElement).scrollIntoView();
            });
            return;
        }

        const form = this.$refs.form as HTMLFormElement;
        if (!form.reportValidity()) {
            return;
        }

        this.saving = true;

        const registration: Partial<ResolvedRegistration> = {
            ...this.registration,
            farm_id: this.farmId || 0,
            vehicle_id: this.vehicleId || 0,
            vehicle_type_id: this.vehicleTypeId || 0,
            vehicle_phase_id: this.vehiclePhaseId || 0,
            notification_id: this.notificationId,
            notification_type_id: this.notificationTypeId,
            ticket_id: this.ticketId,
            caused_by: this.causedBy,
            causes: this.causes,
            actions: this.actions,
            contacted_farmer_phone: this.contactedFarmerPhone,
            contacted_farmer_ticket: this.contactedFarmerTicket,
            contacted_lely_center_technician_phone:
                this.contactedLelyCenterTechnicianPhone,
            contacted_lely_next_technician_phone:
                this.contacterLelyNextTechnicianPhone,
            contacted_developer_phone: this.contactedDeveloperPhone,
            contacted_developer_ticket: this.contactedDeveloperTicket,
            contacted_developer_whatsapp: this.contactedDeveloperWhatsapp,
        };

        try {
            if (registration.id) {
                await axios.put(
                    `/resolved-registrations/${registration.id}`,
                    registration,
                );
            } else {
                await axios.post('/resolved-registrations', registration);
            }
        } catch (error) {
            console.log(error);
            await this.$bvModal.msgBoxOk('Something went wrong while saving your registration. Please try again.');

            return;
        }

        this.$emit('close');
    }

    async deleteRegistration(): Promise<void> {
        if (!this.registration?.id) {
            return;
        }

        const confirm = await this.$bvModal.msgBoxConfirm(
            'Delete the registration?',
            {
                centered: true,
                size: 'sm',
                bodyClass: 'font-weight-bold',
            },
        );

        if (!confirm) {
            return;
        }

        await axios.delete('resolved-registrations/' + this.registration.id);

        this.$emit('close');
    }

    get possibleActions(): { label: string; value: string }[] {
        if (!this.vehicleTypeId) {
            return [];
        }

        return this.resolvedRegistrationPossibleActionsByVehicleTypeId(
            this.vehicleTypeId,
        ).map((action) => ({
            label: action,
            value: action,
        }));
    }

    get possibleCauses(): { label: string; value: string }[] {
        if (!this.vehicleTypeId) {
            return [];
        }

        return this.resolvedRegistrationPossibleCausesByVehicleTypeId(
            this.vehicleTypeId,
        ).map((cause) => ({
            label: cause,
            value: cause,
        }));
    }

    get vehicleTypeId(): number | null {
        const vehicle = this.vehicleId
            ? this.vehicleById(this.vehicleId)
            : null;

        if (!vehicle) {
            return null;
        }

        return this.vehicleTypeById(vehicle.vehicle_type_id)?.id || null;
    }

    async fetchNotification(notificationId: number): Promise<Notification> {
        return (await axios.get(`/notifications/${notificationId}`)).data;
    }

    @Watch('hasTimeRegistrations')
    onHasTimeRegistrationsChanged(newValue: boolean): void {
        if (newValue) {
            this.showTimeRegistrationWarning = false;
        }
    }
}
